export { areThereDuplicationInArray } from './lib/functions/are-there-duplication-in-array';
export { resolveBoolean } from './lib/resolver/resolve-boolean';
export { resolveFloat } from './lib/resolver/resolve-float';
export { resolveInt } from './lib/resolver/resolve-int';
export { resolveNumber } from './lib/resolver/resolve-number';
export { resolveString } from './lib/resolver/resolve-string';
export { lowercaseFirstChar } from './lib/string-manipulation/lowercase-first-char';
export { ensureItemsArray } from './lib/functions/ensure-items-array';
export { EnsureItemsArrayPipe } from './lib/pipes/ensure-items-array.pipe';
